import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getWoundCareSelector } from '../../procedures/woundCare/selectors'
import { IWoundCareState } from '../../procedures/woundCare/store/woundCare.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'

export function* addWoundCareItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const woundCareState: IWoundCareState = yield select(getWoundCareSelector)
  const {
    pta,
    addToTimeline,
    key,
    time,
    date,
    assessedBy,
    attempts,
    successfulAttempt,
    comments,
    isEkgImport,
    actions,
  } = woundCareState
  const actionNames: string[] =
    actions?.map((action) => action?.name).filter((name): name is string => name !== undefined) || []
  if (addToTimeline) {
    const clientCorrelationId = generateClientCorrelationId(
      nemsisCodeOptions,
      TimelineConstants.WOUND_CARE_PROCEDURE,
      actionNames,
      {
        filter1: null,
        filter2: null,
        filter3: null,
      },
      key
    )
    const assessedByLabel = assessedBy?.name || ''
    const successfulAttemptLabel = successfulAttempt ? 'Yes' : 'No'
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Wound Care',
      eventSubHeader: `By ${assessedByLabel},
      Attempts: ${attempts}, Success: ${successfulAttemptLabel}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_WOUND_CARE_PROCEDURE_ITEM,
      defaultHref: TabConstants.WOUND_CARE_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addWoundCareItemSaga() {
  yield takeLatest([TimelineConstants.ADD_WOUND_CARE_ITEM], addWoundCareItem)
}
